import React from 'react';
import { NavIcon } from '../../NavIcon';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';

export const NotificationEmptyState: React.FC<{ variant?: 'dropdown' | 'sheet' }> = ({
  variant = 'dropdown'
}) => {
  const isSheet = variant === 'sheet';
  const { CONVERSATIONS } = useFeatureFlags();
  return (
    <li
      className={
        isSheet
          ? 'flex min-h-[60vh] w-full flex-col items-center justify-center px-6 py-12'
          : 'flex h-64 w-full flex-col items-center justify-center px-6 py-8'
      }
    >
      {/* Estado vacío calmo: un ícono en círculo lavado azul, sin halo. */}
      <span className="grid h-12 w-12 place-items-center rounded-full bg-frost-brand-wash text-frost-brand">
        <NavIcon name="bell" className="text-fs-18" />
      </span>
      <p className="mt-4 text-fs-14 font-semibold tracking-[-0.005em] text-frost-ink">Nada por ahora</p>
      <p className="mt-1 max-w-[32ch] text-center text-fs-12-5 leading-relaxed text-frost-ink-mid">
        {CONVERSATIONS
          ? 'Cuando tengas una reserva, cancelación, reembolso o mensaje nuevo, lo vas a ver acá.'
          : 'Cuando tengas una reserva, cancelación o reembolso nuevo, lo vas a ver acá.'}
      </p>
    </li>
  );
};
